import { useEffect, useState } from "react";
import { Loading } from "@components";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import * as API from "@api";

export default function ProductPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!data) {
      API.Articles.create({
        title: `New Article`,
        language_id: 1,
        category_id: 1,
      })
        .then((res) => {
          if (!res || res?.error) {
            throw new Error("Error while creating article");
          }

          setData(res?.data);
        })
        .catch((err) => {
          return message.error(
            err?.message || "Error while creating article",
            2
          );
        });
    }
  }, [data]);

  if (data?.id) {
    return <Navigate to={`/articles/edit/${data?.id}`} />;
  }

  return <Loading />;
}
